import axios from "axios";
export var bucketApi = axios.create({
    baseURL: "/api/object-storage-ws",
    headers: {
        "X-API-KEY": process.env.BUCKET_API_KEY,
    },
});
